<template>
  <div>
    <vx-card>
      <heading size="h2" style-size="h4" class="mb-3">
        Your Virtual Tour and Job Experience Induction
      </heading>
      <p class="my-5">
        Please watch the video below to get an understanding of a Police Station layout and
        environment.
      </p>
      <p class="my-5">
        <strong
          >You must scroll down and download the Induction Sheet and read it carefully. This is
          compulsory!</strong
        >
      </p>

      <div class="vx-row mt-10 mb-5">
        <div class="vx-col xl:w-2/3 w-full mx-auto">
          <custom-video
            aria-label="Watch video to get an understanding of a Police Station layout and environment"
            elem-id="video-btn-1"
            :video-image="video.image"
            :video-url="video.url"
            video-type="video"
          />
        </div>
      </div>
    </vx-card>
    <vx-card>
      <vs-list>
        <vs-list-item
          title="Induction Sheet"
          subtitle="An overview of what is expected of you and the rules you must follow."
        >
          <a
            class="btn btn-primary btn-size-medium"
            :href="'content/policing/induction_sheet.pdf' | blob_url"
            target="_blank"
          >
            Download
          </a>
        </vs-list-item>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';
import CustomVideo from '@/components/CustomVideo.vue';

export default {
  components: { CustomVideo },
  data() {
    return {};
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    video() {
      return {
        url:
          $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
          '/content/' +
          this.experience.vje.folder_name +
          '/virtual_tour.mp4',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name +
          '/virtual_tour.jpg'),
      };
    },
  },
  methods: {
    showVideoPopup(url, elemId) {
      store.dispatch('popup/showVideoPopup', url);
      store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', +this.$route.params.id);
  },
};
</script>
